export default __webpack_public_path__ + "static/media/jsrbrtable_Wds.fe1d7132.webp";